import React, { useMemo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Form, Formik, FormikHelpers } from "formik";
import { validatorFactory, ValidatorType } from "../../utils/form/validators";
import FormInput from "../../utils/form/FormInput";
import FormMultiSelect from "../../utils/form/FormMultiSelect";
import { useNavigate } from 'react-router-dom';
import { backendURL, useApiFetch } from "../../utils/api";
import { useNotifications } from "../../contexts/NotificationContext";
import { getAllShootingEventsConfigs } from "../../configs/utils/ShootingEventConfigFactory";
import { useAuth } from "../../contexts/AuthContext.tsx";

function AddCompetition() {
    const navigate = useNavigate();
    const { success } = useNotifications();
    const apiFetch = useApiFetch();
    const { getAccountId } = useAuth();
    const shootingEventsConfigs = useMemo(() => getAllShootingEventsConfigs(), []);

    interface ValidationErrors {
        competitionName?: string[];
        shootingEvents?: string[];
    }

    interface FormValues {
        competitionName: string;
        competitionDate: string;
        shootingEvents: string[];
    }

    const initialValues: FormValues = {
        competitionName: "",
        competitionDate: "",
        shootingEvents: []
    };

    function validate(values: FormValues): ValidationErrors {
        const errors: ValidationErrors = {};

        const competitionNameErrors = validatorFactory(values.competitionName, ValidatorType.COMPETITION_NAME);
        if (competitionNameErrors.length > 0) {
            errors.competitionName = competitionNameErrors;
        }

        if (values.shootingEvents.length === 0) {
            errors.shootingEvents = ["Musisz wybrać co najmniej jedną konkurencję"];
        }

        return errors;
    }

    const handleSubmit = async (
        values: FormValues,
        { setSubmitting }: FormikHelpers<FormValues>): Promise<void> => {
        try {
            const data = await apiFetch(`${backendURL}/competitions`, {
                method: "POST",
                body: JSON.stringify({
                    name: values.competitionName,
                    date: values.competitionDate,
                    shootingEventIds: values.shootingEvents,
                    reporterId: getAccountId(),
                }),
                includeAuth: true
            });
            success("Zawody dodane pomyślnie. Aby wprowadzić wyniki, przejdź do zakładki Zarządzaj zawodami", 10000);
            navigate("/");
        } catch (err) {
            setSubmitting(false);
        }
    }

    const shootingEventsOptions = shootingEventsConfigs.map((event) => ({
        id: event.shootingEventId,
        label: event.shootingEventName
    }));

    return (
        <Container>
            <Row>
                <Col xl={8} md={10} xs={12} className="mx-auto">
                    <div className="py-3">
                        <h1 className="font-weight-light text-center mb-4">Dodaj zawody</h1>
                        <Formik<FormValues>
                            initialValues={initialValues}
                            validate={validate}
                            onSubmit={(values, helpers) => handleSubmit(values, helpers)}>

                            <Form className={"row"}>
                                <FormInput name="competitionName" placeholder="Nazwa zawodów" type="text" className="col-12"
                                    errorClassname="text-danger mt-1" />
                                <FormInput name="competitionDate" placeholder="Data zawodów" type="date" className="col-12 mt-4"
                                    errorClassname="text-danger mt-1" />
                                <FormMultiSelect name="shootingEvents" placeholder="Konkurencje" options={shootingEventsOptions} className="col-12 mt-4"
                                    errorClassname="text-danger mt-1" />

                                <div className="col-12 d-flex justify-content-center mt-4">
                                    <button className="btn btn-dark btn-block dim" type="submit">
                                        Dodaj zawody
                                    </button>
                                </div>
                            </Form>
                        </Formik>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default AddCompetition;